module.exports = __webpack_public_path__ + "static/media/46pic.a9a51845.jpg";